const theme = THEME;
// here you can change themes without having to rebuild
export default theme;
